import { rj } from "react-rocketjump"
import rjList, {
  nextPreviousPaginationAdapter,
} from "react-rocketjump/plugins/list"
import api from "../api"
import { PAGE_SIZE } from "../consts"

export const RivenditaState = rj(
  rjList({
    pagination: nextPreviousPaginationAdapter,
    pageSize: PAGE_SIZE,
  }),
  {
    mutations: {
      removeRivendita: {
        effect: (t) => (entity) =>
          api
            .auth(t)
            .mapResponse(() => entity)
            .delete(`/api/rivendite/${entity.id}`),
        updater: "deleteItem",
        // Uncomment to make delete optimistic
        // optimistiResult: entity => entity,
      },
      addRivendita: {
        effect: (t) => (entity) => api.auth(t).post("/api/rivendite", entity),
        updater: "insertItem",
      },
      updateRivendita: {
        effect: (t) => (entity) =>
          api.auth(t).put(`/api/rivendite/${entity.id}/`, entity),
        updater: "updateItem",
      },
    },
    name: "RivenditeState",
    effectCaller: "configured",
    effect: (t) => (params = {}) => api.auth(t).get("/api/rivendite", params),
    computed: {
      pagination: "getPagination",
      list: "getList",
      loading: "isLoading",
    },
  }
)
